export type TelemToml = {
  telemetry: TelemetrySection
}

export type TelemetrySection = {
  // `definitions` specifies the meaning of each consecutive bit of the
  // enabled telemetry bit field (expected size <= 128). definitions[0]
  // specifies the meaning of bit 0.
  definitions: TelemIdxEntry[]

  // `fields` indicate which sequence of U32 tags contain the bit field for
  // enabled telemetry. fields[0] indicates which tag has bits 31-0 of the
  // bit field, fields[1] indicates which tag has bits 63-32 of the bit
  // field, etc. It is expected that there will always be 4 of these, for a
  // bit field of size 128.
  fields: TelemField[]
}

// These should be all the types used in telem.toml
// Keep in sync with isFieldTypeValid, below.
export type TelemIdxType = 'TYPE_BOOL' | 'TYPE_FLOAT' | 'TYPE_INT32' | 'TYPE_UINT32' | 'TYPE_UINT16'

export function isFieldTypeValid(fieldType: string | TelemIdxType): fieldType is TelemIdxType {
  switch (fieldType) {
    case 'TYPE_BOOL':
      return true
    case 'TYPE_FLOAT':
      return true
    case 'TYPE_INT32':
      return true
    case 'TYPE_UINT32':
      return true
    case 'TYPE_UINT16':
      return true
    default:
      return false
  }
}

export type TelemIdxEntry = {
  name: string
  type: TelemIdxType
  units?: string
  deprecated: boolean
}

export type TelemField = {
  name: string // Compare against `name` in TagDefinition
  type: 'u32' // TagTypeName
}

export type TelemValue = number | boolean
